import { lazy } from 'react';
import {
	dashboardPagesMenu,
	demoPagesMenu,
	landingPagesMenu,
	mainPagesMenu,
	pageLayoutTypesPagesMenu,
} from '../menu';
import SPCallback from '../pages/auth/sp-callback/SPCallback';
import SPLogin from '../pages/auth/sp-login/SPLogin';
import HomePage from '../pages/home/HomePage';
import Login from '../pages/presentation/auth/Login';

const LANDING = {
	DASHBOARD: lazy(() => import('../pages/presentation/dashboard/DashboardPage')),
	POLICY: lazy(() => import('../pages/policy/PolicyPage')),
	CONTACT: lazy(() => import('../pages/contact/ContactPage')),
	PRICING: lazy(() => import('../pages/pricing/PricingPage')),
};
const MAIN = {
	STORES: lazy(() => import('../pages/stores/StorePage')),
};
const AUTH = {
	PAGE_404: lazy(() => import('../pages/presentation/auth/Page404')),
};
const PAGE_LAYOUTS = {
	HEADER_SUBHEADER: lazy(() => import('../pages/presentation/page-layouts/HeaderAndSubheader')),
	HEADER: lazy(() => import('../pages/presentation/page-layouts/OnlyHeader')),
	SUBHEADER: lazy(() => import('../pages/presentation/page-layouts/OnlySubheader')),
	CONTENT: lazy(() => import('../pages/presentation/page-layouts/OnlyContent')),
	BLANK: lazy(() => import('../pages/presentation/page-layouts/Blank')),
	ASIDE: lazy(() => import('../pages/presentation/aside-types/DefaultAsidePage')),
	MINIMIZE_ASIDE: lazy(() => import('../pages/presentation/aside-types/MinimizeAsidePage')),
};

const presentation = [
	{
		path: landingPagesMenu.home.path,
		element: <HomePage />,
	},
	{
		path: landingPagesMenu.policy.path,
		element: <LANDING.POLICY />,
	},
	{
		path: landingPagesMenu.contact.path,
		element: <LANDING.CONTACT />,
	},
	{
		path: landingPagesMenu.pricing.path,
		element: <LANDING.PRICING />,
	},
	{
		path: dashboardPagesMenu.dashboard.path,
		element: <LANDING.DASHBOARD />,
	},
	{
		path: mainPagesMenu.stores.path,
		element: <MAIN.STORES />,
	},
	{
		path: demoPagesMenu.page404.path,
		element: <AUTH.PAGE_404 />,
	},
	{
		path: demoPagesMenu.login.path,
		element: <Login />,
	},
	{
		path: demoPagesMenu.signUp.path,
		element: <Login isSignUp />,
	},
	{
		path: demoPagesMenu.spLogin.path,
		element: <SPLogin />,
	},
	{
		path: demoPagesMenu.spCallback.path,
		element: <SPCallback />,
	},

	/** ************************************************** */

	/**
	 * Page Layout Types
	 */
	{
		path: pageLayoutTypesPagesMenu.blank.path,
		element: <PAGE_LAYOUTS.BLANK />,
	},
	{
		path: pageLayoutTypesPagesMenu.pageLayout.subMenu.headerAndSubheader.path,
		element: <PAGE_LAYOUTS.HEADER_SUBHEADER />,
	},
	{
		path: pageLayoutTypesPagesMenu.pageLayout.subMenu.onlyHeader.path,
		element: <PAGE_LAYOUTS.HEADER />,
	},
	{
		path: pageLayoutTypesPagesMenu.pageLayout.subMenu.onlySubheader.path,
		element: <PAGE_LAYOUTS.SUBHEADER />,
	},
	{
		path: pageLayoutTypesPagesMenu.pageLayout.subMenu.onlyContent.path,
		element: <PAGE_LAYOUTS.CONTENT />,
	},
	{
		path: pageLayoutTypesPagesMenu.asideTypes.subMenu.defaultAside.path,
		element: <PAGE_LAYOUTS.ASIDE />,
	},
	{
		path: pageLayoutTypesPagesMenu.asideTypes.subMenu.minimizeAside.path,
		element: <PAGE_LAYOUTS.MINIMIZE_ASIDE />,
	},
];
const contents = [...presentation];

export default contents;
